import { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

const HomeCharts = ({ label, color, data }) => {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    const months = ['Jul','Aug','Sep','Oct','Nov','Dec','Jan','Feb','Mar','Apr','May','Jun'];

    const ctx = canvasRef.current.getContext("2d");

    // Destroy previous chart if exists
    if (chartRef.current) {
      chartRef.current.destroy();
    }

    // Gradient for bars
    const gradient = ctx.createLinearGradient(0, 0, 0, 300);
    gradient.addColorStop(0, color);
    gradient.addColorStop(0.6, color);
    gradient.addColorStop(1, color + "80");

    chartRef.current = new Chart(ctx, {
      type: "bar",
      data: {
        labels: months,
        datasets: [{
          label,
          data,
          borderColor: color,
          backgroundColor: gradient,
          borderRadius: 10,
          borderWidth: 0,
          barPercentage: 0.25,
          categoryPercentage: 0.7
        }]
      },
      options: {
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            enabled: true,
            callbacks: {
              title: () => "",
              label: (ctx) => `${ctx.dataset.label}: ${ctx.raw}`
            }
          }
        },
        scales: {
          x: { type: "category", ticks: { autoSkip: false } },
          y: { beginAtZero: true }
        }
      }
    });

    // Cleanup
    return () => chartRef.current?.destroy();
  }, [label, color, data]);

  return (
    <div style={{ height: "250px" }}>
      <canvas ref={canvasRef}></canvas>
    </div>
  );
};

export default HomeCharts;